import OrderCart from "./order-cart";

export default function VendorOrders() {
    return (
        <>

            <OrderCart/>
        </>
    )
}